// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"85":"b4ad22a3","477":"f98e3160"}[chunkId] + ".chunk.css";
};